import { CloseOutlined } from "@ant-design/icons";
import { Pause } from "react-feather";

import "./stylesUpdateStatusModal.css";
import { Input, Select } from "antd";
import { useEffect, useState } from "react";

function UpdateStatusModal({ handleCancel, selectedRecord, changeStatus }) {
  const [reason, setReason] = useState(selectedRecord?.reason);

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const handleClose = () => {
    handleCancel();
    setReason("");
  };

  const handleChangeStatus = (status) => {
    changeStatus({ ...selectedRecord, status, reason });
    handleClose();
  };

  useEffect(() => {
    setReason(selectedRecord?.reason);
  }, [selectedRecord]);

  return (
    <div className="suspend-modal-container prize-redemption-manual-review-update-status-modal">
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title">Accept/Decline</h2>
        </div>
        <CloseOutlined onClick={handleClose} className="close-icon" />
      </div>

      <div className="divider" />

      <div className="modal-content">
        <div className="current-status-container">
          <p className="current-status-label">Current Status:</p>
          <p className="current-status-value">
            {selectedRecord?.status.charAt(0).toUpperCase() +
              selectedRecord?.status.slice(1)}
          </p>
        </div>
        <div className="transaction-info-item">
          <Input.TextArea
            type="text"
            value={reason}
            maxLength={255}
            rows={3}
            placeholder="Enter reason"
            onChange={handleReasonChange}
          />
          <span className="max-length">{reason.length}/255</span>
        </div>
      </div>

      <div className="divider" />
      <div className="modal-footer">
        <div className="buttons">
          <button
            className={`cancel-button ${reason.length === 0 ? "disabled" : ""}`}
            disabled={reason.length === 0}
            onClick={() => {
              handleChangeStatus("declined");
            }}
          >
            Decline
          </button>
          <button
            className={`save-button ${reason.length === 0 ? "disabled" : ""}`}
            disabled={reason.length === 0}
            onClick={() => {
              handleChangeStatus("accepted");
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateStatusModal;
